import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Container,
  Box,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const InternationalDesk = () => {
  const theme = useTheme();

  const cardsData = [
    {
      title: "Xiang Ying",
      role: "Factory Setup & Business Manager",
      desc: "Xiang Ying supports international businesses in establishing and scaling manufacturing operations in India. She assists with factory setup, vendor development, operational planning, and ongoing compliance.",
      initials: "XY",
    },
    {
      title: "Cannie",
      role: "India Market Entry Research",
      desc: "Cannie advises international companies exploring the Indian market. She conducts industry research, evaluates regulatory frameworks, and helps structure market entry plans aligned with local practices.",
      initials: "C",
    },
    {
      title: "Erina",
      role: "Finance & Client Relations",
      desc: "Erina manages client relationships and finance advisory for Taiwan, UAE, and Japan. She supports businesses with cross-border structuring, financial coordination, and ongoing governance.",
      initials: "E",
    },
    {
      title: "Niny",
      role: "International Business Consultant",
      desc: "Niny advises companies across APAC on business expansion, marketing strategy, and financial planning. She helps organisations structure growth strategies in line with regional regulatory norms.",
      initials: "N",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background decoration */}
      <LanguageIcon
        sx={{
          position: "absolute",
          right: -50,
          top: 50,
          fontSize: 400,
          color: "rgba(0,0,0,0.02)",
          zIndex: 0,
          display: { xs: "none", md: "block" },
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1 }}>
        <Box textAlign="center" mb={8}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#333",
              fontFamily: "'Roboto Slab', serif",
              fontSize: { xs: "2rem", md: "2.8rem" },
              mb: 2,
            }}
          >
            Our{" "}
            <span style={{ color: "var(--primary-color)" }}>
              International Desk
            </span>
          </Typography>
          <Typography
            sx={{
              color: "#777",
              maxWidth: 600,
              mx: "auto",
              fontSize: "1.1rem",
            }}
          >
            Connecting global enterprises with local intelligence through our
            specialized country desks and multi-lingual experts.
          </Typography>
        </Box>

        <Box
          sx={{
            "& .slick-dots": { bottom: "-50px" },
            "& .slick-dots li button:before": {
              fontSize: "12px",
              color: "var(--primary-color)",
            },
            "& .slick-dots li.slick-active button:before": {
              color: "var(--primary-color)",
            },
          }}
        >
          <Slider {...settings}>
            {cardsData.map((card, idx) => (
              <Box key={idx} sx={{ px: 2, py: 2 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    height: "100%",
                    minHeight: "350px",
                    borderRadius: "24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    bgcolor: "#fff",
                    border: "1px solid #eee",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                      borderColor: "var(--primary-color)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: "50%",
                      bgcolor: "var(--primary-color)",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "24px",
                      fontWeight: 700,
                      mb: 3,
                      boxShadow: "0 4px 15px rgba(26, 66, 161, 0.3)",
                    }}
                  >
                    {card.initials}
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, mb: 1, color: "#222" }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "var(--primary-color)",
                      fontWeight: 600,
                      mb: 3,
                    }}
                  >
                    {card.role}
                  </Typography>
                  <Typography
                    sx={{ color: "#666", lineHeight: 1.7, fontSize: "0.95rem" }}
                  >
                    {card.desc}
                  </Typography>
                </Paper>
              </Box>
            ))}
          </Slider>
        </Box>
      </Container>
    </Box>
  );
};

export default InternationalDesk;
